export const resizerStyle = {
    // width: '2px',
    cursor: 'col-resize',
    margin: '0px',
    height: 'calc(100vh - 129px)!important',
    borderRightWidth: 0,
    borderLeftWidth: 4,
};
